import React from 'react';
import styled from 'styled-components';

import theme from '../../style/theme';

const FooterStyle = styled.footer`
    padding: 2rem 1rem;
    background-color: #6BB951;
`;

const WrapperStyles = styled.div`
  position: relative;
  color: #fff;
  font-size: .9rem;
  max-width: ${theme.maxContainer.sm};
  margin: 0 auto;
`;

const ContactWrapperStyle = styled.div`
  display: inline-block;
  margin-left: 3rem;
`;

const AddressWrapperStyle = styled.div`
  display: inline-block;
`;

const ContactInfoStyle = styled.span`
  display: block;
`;

const renderfooterContent = content => (
  <div key={content.address.substr(0, 5)}>
    <AddressWrapperStyle>
      <p>{content.address}</p>
    </AddressWrapperStyle>
    <ContactWrapperStyle>
      <ContactInfoStyle>{content.fone}</ContactInfoStyle>
      <ContactInfoStyle>{content.email}</ContactInfoStyle>
    </ContactWrapperStyle>
  </div>
);

const Footer = (props) => {
  const { footerContent } = props;
  return (
    <FooterStyle>
      <WrapperStyles>
        {footerContent.map(item => renderfooterContent(item))}
      </WrapperStyles>
    </FooterStyle>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Index/Footer.jsx